function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{enable-background:new    ;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "September"
}, /*#__PURE__*/React.createElement("g", {
  id: "Call-new",
  transform: "translate(-1096.000000, -376.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-7",
  transform: "translate(970.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-16",
  transform: "translate(110.000000, 340.000000)"
}, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M24.8,27.8c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.1,0.5,0.2,0.7,0.2c0.2,0,0.3,0,0.5-0.1s0.2-0.2,0.3-0.3 c0.1-0.1,0.1-0.2,0.1-0.4c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-0.9-0.4c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.2-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.4-0.5-0.7c-0.1-0.3-0.2-0.6-0.2-1c0-0.5,0.1-0.9,0.4-1.2s0.6-0.6,1-0.8 c0.4-0.2,0.9-0.3,1.4-0.3c0.5,0,1,0.1,1.3,0.3s0.7,0.4,0.9,0.6c0.2,0.3,0.4,0.5,0.6,0.8l-1.4,0.8c-0.1-0.2-0.2-0.3-0.4-0.5 c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0.1s-0.2,0.1-0.3,0.2s-0.1,0.2-0.1,0.3 c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,0.7,0.3c0.3,0.1,0.5,0.2,0.8,0.4 s0.4,0.3,0.6,0.5s0.3,0.4,0.4,0.7s0.2,0.5,0.2,0.9c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.6-0.6,0.8c-0.3,0.2-0.6,0.4-0.9,0.5 c-0.3,0.1-0.7,0.2-1.1,0.2c-0.5,0-1-0.1-1.4-0.3c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.6-0.6-0.7-1l1.3-0.9 C24.4,27.4,24.6,27.6,24.8,27.8z"
}))))));

var SvgS = function SvgS(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgS, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/S.19228306.svg";
export { ForwardRef as ReactComponent };